import { render } from "./LegoMessage.vue?vue&type=template&id=721d0a32"
import script from "./LegoMessage.vue?vue&type=script&lang=js"
export * from "./LegoMessage.vue?vue&type=script&lang=js"
script.render = render

export default script